import React from "react";
import { Panel, PanelBody, PanelHeader } from "../../../util/panel";
import { Breadcrumb, Button, Col, Empty, Modal, Row, Table } from "antd";
import { Link, useParams } from "react-router-dom";
import { useApi } from "../../../../hooks/http2";
import { displayTotal } from "../../../../utils/helper";
import dayjs from "dayjs";
import { axios } from "../../../../utils/useAxios";

const TrackingDetail = () => {
  const params = useParams();

  const qr = useApi(
    {
      url: `/store-qr/tracking/${params.bill_no}`,
      token: true,
    },
    [params.bill_no]
  );

  const handleDelete = () => {
    Modal.confirm({
      title: "ยืนยันการลบ QR",
      content: "จะไม่สามารถคืนค่าได้หากทำการลบไปแล้ว",
      maskClosable: false,
      cancelText: "ปิด",
      okText: "ยืนยัน",
      onOk: async () => {
        return new Promise(async (resolve, reject) => {
          try {
            await axios.post(`/store-qr/tracking/${params.bill_no}/delete`);
            resolve("");
          } catch (error) {
            reject(error?.response?.data?.message || error?.message);
          }
        })
          .then(() => {
            Modal.success({
              title: "สำเร็จ",
              content: "ลบ QR เรียบร้อย",
              okText: "ปิด",
              onOk: () => qr.reload(),
            });
          })
          .catch((reason) => {
            Modal.error({
              title: "ผิดพลาด",
              content: reason,
              okText: "ปิด",
            });
          });
      },
    });
  };

  return (
    <>
      <Breadcrumb className="mb-2">
        <Breadcrumb.Item>
          <Link to="/">หน้าหลัก</Link>
        </Breadcrumb.Item>
        <Breadcrumb.Item>Store QR</Breadcrumb.Item>
        <Breadcrumb.Item>
          <Link to="/store-qr/tracking">รายการใบเสร็จ</Link>
        </Breadcrumb.Item>
        <Breadcrumb.Item>{params.bill_no}</Breadcrumb.Item>
      </Breadcrumb>
      <Panel>
        <PanelHeader>รายการ QR Code ของใบเสร็จ {params.bill_no}</PanelHeader>
        <PanelBody>
          <Row gutter={[16, 16]} className="mb-2">
            <Col className="text-right">
              <Button
                type="danger"
                ghost
                disabled={!qr.fetch?.length}
                onClick={handleDelete}
              >
                ลบ QR
              </Button>
            </Col>
          </Row>
          <Table
            size="small"
            bordered
            loading={qr.loading}
            dataSource={qr.fetch || []}
            rowKey="id"
            pagination={{
              size: "default",
              showLessItems: true,
              showTotal: displayTotal,
            }}
            locale={{
              emptyText: (
                <Empty
                  image={Empty.PRESENTED_IMAGE_SIMPLE}
                  description="ไม่มีข้อมูล QR (อาจถูกลบไปแล้ว)"
                />
              ),
            }}
          >
            <Table.Column
              key="no"
              title="ลำดับ"
              align="right"
              render={(text, record, index) => index + 1}
            />
            <Table.Column
              key="ref_product_code"
              title="รหัสสินค้าเซ็ต"
              dataIndex="ref_product_code"
              align="center"
              render={(ref_product_code) => ref_product_code || "-"}
            />
            <Table.Column
              key="product_code"
              title="รหัสสินค้า"
              dataIndex="product_code"
              align="center"
            />
            <Table.Column
              key="product_name"
              title="ชื่อสินค้า"
              dataIndex="product_name"
            />
            <Table.Column
              key="qr_running"
              title="Running"
              dataIndex="qr_running"
              align="center"
            />
            <Table.Column
              key="trans_date"
              title="วันที่สแกน"
              dataIndex="trans_date"
              align="center"
              render={(trans_date) =>
                trans_date ? dayjs(trans_date).format("DD/MM/YYYY HH:mm") : "-"
              }
            />
          </Table>
        </PanelBody>
      </Panel>
    </>
  );
};

export default TrackingDetail;
